/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponse } from '../model';
// @ts-ignore
import { GetTotalDataResponse } from '../model';
// @ts-ignore
import { GetUnitResponse } from '../model';
// @ts-ignore
import { GetUnitsResponse } from '../model';
// @ts-ignore
import { PostUnitRequest } from '../model';
// @ts-ignore
import { PostUnitsResponse } from '../model';
// @ts-ignore
import { PutAssignVariableRequest } from '../model';
// @ts-ignore
import { PutAssignVariableResponse } from '../model';
// @ts-ignore
import { PutSortVariableRequest } from '../model';
// @ts-ignore
import { PutSortVariableResponse } from '../model';
// @ts-ignore
import { PutUnitRequest } from '../model';
// @ts-ignore
import { PutUnitsResponse } from '../model';
/**
 * UnitsApi - axios parameter creator
 * @export
 */
export const UnitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostUnitRequest} postUnitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUnit: async (postUnitRequest: PostUnitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postUnitRequest' is not null or undefined
            assertParamExists('addUnit', 'postUnitRequest', postUnitRequest)
            const localVarPath = `/api/units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postUnitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutAssignVariableRequest} putAssignVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUnitVariable: async (id: string, putAssignVariableRequest: PutAssignVariableRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createUnitVariable', 'id', id)
            // verify required parameter 'putAssignVariableRequest' is not null or undefined
            assertParamExists('createUnitVariable', 'putAssignVariableRequest', putAssignVariableRequest)
            const localVarPath = `/api/units/{id}/variables/assign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putAssignVariableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnit: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUnit', 'id', id)
            const localVarPath = `/api/units/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutUnitRequest} putUnitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUnit: async (id: string, putUnitRequest: PutUnitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('editUnit', 'id', id)
            // verify required parameter 'putUnitRequest' is not null or undefined
            assertParamExists('editUnit', 'putUnitRequest', putUnitRequest)
            const localVarPath = `/api/units/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putUnitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalUnit: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/units/get-total-unit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUnitById', 'id', id)
            const localVarPath = `/api/units/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitByLocationId: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getUnitByLocationId', 'locationId', locationId)
            const localVarPath = `/api/units/location/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnits: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutSortVariableRequest} putSortVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSortOrderUnitVariable: async (id: string, putSortVariableRequest: PutSortVariableRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSortOrderUnitVariable', 'id', id)
            // verify required parameter 'putSortVariableRequest' is not null or undefined
            assertParamExists('updateSortOrderUnitVariable', 'putSortVariableRequest', putSortVariableRequest)
            const localVarPath = `/api/units/{id}/variables/sort`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putSortVariableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitsApi - functional programming interface
 * @export
 */
export const UnitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostUnitRequest} postUnitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUnit(postUnitRequest: PostUnitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostUnitsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUnit(postUnitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutAssignVariableRequest} putAssignVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUnitVariable(id: string, putAssignVariableRequest: PutAssignVariableRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAssignVariableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUnitVariable(id, putAssignVariableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUnit(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUnit(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutUnitRequest} putUnitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editUnit(id: string, putUnitRequest: PutUnitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutUnitsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editUnit(id, putUnitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalUnit(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTotalDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalUnit(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnitById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnitById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnitByLocationId(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnitsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnitByLocationId(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnits(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnitsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnits(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutSortVariableRequest} putSortVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSortOrderUnitVariable(id: string, putSortVariableRequest: PutSortVariableRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutSortVariableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSortOrderUnitVariable(id, putSortVariableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UnitsApi - factory interface
 * @export
 */
export const UnitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitsApiFp(configuration)
    return {
        /**
         * 
         * @param {PostUnitRequest} postUnitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUnit(postUnitRequest: PostUnitRequest, options?: any): AxiosPromise<PostUnitsResponse> {
            return localVarFp.addUnit(postUnitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutAssignVariableRequest} putAssignVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUnitVariable(id: string, putAssignVariableRequest: PutAssignVariableRequest, options?: any): AxiosPromise<PutAssignVariableResponse> {
            return localVarFp.createUnitVariable(id, putAssignVariableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnit(id: string, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.deleteUnit(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutUnitRequest} putUnitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUnit(id: string, putUnitRequest: PutUnitRequest, options?: any): AxiosPromise<PutUnitsResponse> {
            return localVarFp.editUnit(id, putUnitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalUnit(options?: any): AxiosPromise<GetTotalDataResponse> {
            return localVarFp.getTotalUnit(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitById(id: string, options?: any): AxiosPromise<GetUnitResponse> {
            return localVarFp.getUnitById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitByLocationId(locationId: string, options?: any): AxiosPromise<GetUnitsResponse> {
            return localVarFp.getUnitByLocationId(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnits(options?: any): AxiosPromise<GetUnitsResponse> {
            return localVarFp.getUnits(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutSortVariableRequest} putSortVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSortOrderUnitVariable(id: string, putSortVariableRequest: PutSortVariableRequest, options?: any): AxiosPromise<PutSortVariableResponse> {
            return localVarFp.updateSortOrderUnitVariable(id, putSortVariableRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addUnit operation in UnitsApi.
 * @export
 * @interface UnitsApiAddUnitRequest
 */
export interface UnitsApiAddUnitRequest {
    /**
     * 
     * @type {PostUnitRequest}
     * @memberof UnitsApiAddUnit
     */
    readonly postUnitRequest: PostUnitRequest
}

/**
 * Request parameters for createUnitVariable operation in UnitsApi.
 * @export
 * @interface UnitsApiCreateUnitVariableRequest
 */
export interface UnitsApiCreateUnitVariableRequest {
    /**
     * 
     * @type {string}
     * @memberof UnitsApiCreateUnitVariable
     */
    readonly id: string

    /**
     * 
     * @type {PutAssignVariableRequest}
     * @memberof UnitsApiCreateUnitVariable
     */
    readonly putAssignVariableRequest: PutAssignVariableRequest
}

/**
 * Request parameters for deleteUnit operation in UnitsApi.
 * @export
 * @interface UnitsApiDeleteUnitRequest
 */
export interface UnitsApiDeleteUnitRequest {
    /**
     * 
     * @type {string}
     * @memberof UnitsApiDeleteUnit
     */
    readonly id: string
}

/**
 * Request parameters for editUnit operation in UnitsApi.
 * @export
 * @interface UnitsApiEditUnitRequest
 */
export interface UnitsApiEditUnitRequest {
    /**
     * 
     * @type {string}
     * @memberof UnitsApiEditUnit
     */
    readonly id: string

    /**
     * 
     * @type {PutUnitRequest}
     * @memberof UnitsApiEditUnit
     */
    readonly putUnitRequest: PutUnitRequest
}

/**
 * Request parameters for getUnitById operation in UnitsApi.
 * @export
 * @interface UnitsApiGetUnitByIdRequest
 */
export interface UnitsApiGetUnitByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof UnitsApiGetUnitById
     */
    readonly id: string
}

/**
 * Request parameters for getUnitByLocationId operation in UnitsApi.
 * @export
 * @interface UnitsApiGetUnitByLocationIdRequest
 */
export interface UnitsApiGetUnitByLocationIdRequest {
    /**
     * 
     * @type {string}
     * @memberof UnitsApiGetUnitByLocationId
     */
    readonly locationId: string
}

/**
 * Request parameters for updateSortOrderUnitVariable operation in UnitsApi.
 * @export
 * @interface UnitsApiUpdateSortOrderUnitVariableRequest
 */
export interface UnitsApiUpdateSortOrderUnitVariableRequest {
    /**
     * 
     * @type {string}
     * @memberof UnitsApiUpdateSortOrderUnitVariable
     */
    readonly id: string

    /**
     * 
     * @type {PutSortVariableRequest}
     * @memberof UnitsApiUpdateSortOrderUnitVariable
     */
    readonly putSortVariableRequest: PutSortVariableRequest
}

/**
 * UnitsApi - object-oriented interface
 * @export
 * @class UnitsApi
 * @extends {BaseAPI}
 */
export class UnitsApi extends BaseAPI {
    /**
     * 
     * @param {UnitsApiAddUnitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public addUnit(requestParameters: UnitsApiAddUnitRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).addUnit(requestParameters.postUnitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiCreateUnitVariableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public createUnitVariable(requestParameters: UnitsApiCreateUnitVariableRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).createUnitVariable(requestParameters.id, requestParameters.putAssignVariableRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiDeleteUnitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public deleteUnit(requestParameters: UnitsApiDeleteUnitRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).deleteUnit(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiEditUnitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public editUnit(requestParameters: UnitsApiEditUnitRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).editUnit(requestParameters.id, requestParameters.putUnitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public getTotalUnit(options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).getTotalUnit(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiGetUnitByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public getUnitById(requestParameters: UnitsApiGetUnitByIdRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).getUnitById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiGetUnitByLocationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public getUnitByLocationId(requestParameters: UnitsApiGetUnitByLocationIdRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).getUnitByLocationId(requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public getUnits(options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).getUnits(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiUpdateSortOrderUnitVariableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public updateSortOrderUnitVariable(requestParameters: UnitsApiUpdateSortOrderUnitVariableRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).updateSortOrderUnitVariable(requestParameters.id, requestParameters.putSortVariableRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
